module.exports = __webpack_public_path__ + "media/img/favicon-32x32-8ac4c4330f93f83c53b2857e9f1b39ef.png";